import i18n from 'i18next';
import translationHi from './hi/translation';
import translationEn from './en/translation';
import { initReactI18next } from 'react-i18next';

const resources = {
  hi: {
    translation: translationHi,
  },
  en: {
    translation: translationEn,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
